import { Box, Card, CardContent, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import AdminDashboardLayout from "../../../layouts/admin_dashboard_layout/admin_dashboard_layout";
import UploadEMagazineTab from "./upload_emagazine_tab";
import ManageEMagazinesTab from "./manage_emagazines_tab";
import UploadEditorialMemberTab from "./upload_editorial_member_tab";
import ManageEditorialMembersTab from "./manage_editorial_members_tab";
import UploadMagazineTab from "./upload_magazine_tab";
import ManageMagazinesTab from "./manage_magazines_tab";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`yuvagaaz-tabpanel-${index}`}
      aria-labelledby={`yuvagaaz-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function AdminYuvagaazPage() {
  const [currentTab, setCurrentTab] = useState(0);

  return (
    <AdminDashboardLayout>
      <Box flex={1} mt={2} mx={2}>
        <Card sx={{ borderRadius: 1, m: 3 }} elevation={1}>
          <CardContent>
            <Typography variant="h5" fontWeight="600" mb={2}>
              Yuvagaaz Management
            </Typography>

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={currentTab}
                onChange={(_, newValue) => setCurrentTab(newValue)}
                aria-label="yuvagaaz management tabs"
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab label="Add Magazine" id="yuvagaaz-tab-0" />
                <Tab label="Manage Magazines" id="yuvagaaz-tab-1" />
                <Tab label="Add E-Magazine" id="yuvagaaz-tab-2" />
                <Tab label="Manage E-Magazines" id="yuvagaaz-tab-3" />
                <Tab label="Add Committee Member" id="yuvagaaz-tab-4" />
                <Tab label="Manage Committee" id="yuvagaaz-tab-5" />
              </Tabs>
            </Box>

            <TabPanel value={currentTab} index={0}>
              <UploadMagazineTab onSuccess={() => setCurrentTab(1)} />
            </TabPanel>

            <TabPanel value={currentTab} index={1}>
              <ManageMagazinesTab />
            </TabPanel>

            <TabPanel value={currentTab} index={2}>
              <UploadEMagazineTab onSuccess={() => setCurrentTab(3)} />
            </TabPanel>

            <TabPanel value={currentTab} index={3}>
              <ManageEMagazinesTab />
            </TabPanel>

            <TabPanel value={currentTab} index={4}>
              <UploadEditorialMemberTab onSuccess={() => setCurrentTab(5)} />
            </TabPanel>

            <TabPanel value={currentTab} index={5}>
              <ManageEditorialMembersTab />
            </TabPanel>
          </CardContent>
        </Card>
      </Box>
    </AdminDashboardLayout>
  );
}
